import {AsyncValidatorFn, FormControl, ValidationErrors} from '@angular/forms';
import {Observable} from 'rxjs/Observable';

export abstract class BaseAbstract {

    public process(): AsyncValidatorFn | AsyncValidatorFn[] {
        return this.validate().bind(this);
    }

    // ########################################

    protected abstract validate(): (control: FormControl) => Observable<ValidationErrors | null>;

    // ########################################
}
